/**
 * @generated SignedSource<<c52271437586440f0791c9b048212080>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "model"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "month"
    }, v2 = {
        "kind": "Variable",
        "name": "model",
        "variableName": "model"
    }, v3 = {
        "kind": "Variable",
        "name": "month",
        "variableName": "month"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        },
        (v2 /*: any*/)
    ], v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v6 = [
        (v5 /*: any*/)
    ], v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v8 = [
        {
            "kind": "Literal",
            "name": "unit",
            "value": "HOUR"
        }
    ], v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unit",
        "storageKey": null
    }, v11 = [
        (v9 /*: any*/),
        (v10 /*: any*/)
    ], v12 = [
        (v5 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
        }
    ], v13 = [
        (v5 /*: any*/),
        (v7 /*: any*/)
    ], v14 = {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": (v13 /*: any*/),
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "RunningSchedulesInformationByMonthQuery",
            "selections": [
                {
                    "args": [
                        (v2 /*: any*/),
                        (v3 /*: any*/)
                    ],
                    "kind": "FragmentSpread",
                    "name": "RunningSchedulesInformationByMonth_fragment"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "RunningSchedulesInformationByMonthQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v4 /*: any*/),
                    "concreteType": "SchedulableEntityConnection",
                    "kind": "LinkedField",
                    "name": "schedulableEntities",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SchedulableEntityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": (v6 /*: any*/),
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v5 /*: any*/),
                                                (v7 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "color",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": [
                                                        (v3 /*: any*/)
                                                    ],
                                                    "concreteType": "ScheduleTimesByMonthPayload",
                                                    "kind": "LinkedField",
                                                    "name": "scheduleTimesByMonth",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TimeReport",
                                                            "kind": "LinkedField",
                                                            "name": "timeReport",
                                                            "plural": false,
                                                            "selections": (v6 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleTimesByMonthSummary",
                                                            "kind": "LinkedField",
                                                            "name": "summary",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": (v8 /*: any*/),
                                                                    "concreteType": "TimeSpanUnitValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "totalTime",
                                                                    "plural": false,
                                                                    "selections": (v11 /*: any*/),
                                                                    "storageKey": "totalTime(unit:\"HOUR\")"
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": (v8 /*: any*/),
                                                                    "concreteType": "TimeSpanUnitValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "workedTime",
                                                                    "plural": false,
                                                                    "selections": (v11 /*: any*/),
                                                                    "storageKey": "workedTime(unit:\"HOUR\")"
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": (v8 /*: any*/),
                                                                    "concreteType": "TimeSpanUnitValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "absenceTime",
                                                                    "plural": false,
                                                                    "selections": (v11 /*: any*/),
                                                                    "storageKey": "absenceTime(unit:\"HOUR\")"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TimeSummaryByEmployment",
                                                            "kind": "LinkedField",
                                                            "name": "employmentSummaries",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Employment",
                                                                    "kind": "LinkedField",
                                                                    "name": "employment",
                                                                    "plural": false,
                                                                    "selections": (v12 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TimeReportSummaryByEmployment",
                                                                    "kind": "LinkedField",
                                                                    "name": "timeReportSummary",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": (v8 /*: any*/),
                                                                            "concreteType": "TimeSpanUnitValue",
                                                                            "kind": "LinkedField",
                                                                            "name": "expectedWorkTime",
                                                                            "plural": false,
                                                                            "selections": (v11 /*: any*/),
                                                                            "storageKey": "expectedWorkTime(unit:\"HOUR\")"
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TimeReportSummaryByEmploymentAndEvent",
                                                                            "kind": "LinkedField",
                                                                            "name": "eventSummaries",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v14 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isWork",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TimeReportSummaryByEmploymentAndEventPartsSummary",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "nonRegularPartsSummary",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        (v14 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "unit",
                                                                                                    "value": "SECOND"
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "TimeSpanUnitValue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "duration",
                                                                                            "plural": false,
                                                                                            "selections": (v11 /*: any*/),
                                                                                            "storageKey": "duration(unit:\"SECOND\")"
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v10 /*: any*/),
                                                                                (v9 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CompensatoryTimesByTimeStore",
                                                            "kind": "LinkedField",
                                                            "name": "compensatoryTimes",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EmploymentSetting",
                                                                    "kind": "LinkedField",
                                                                    "name": "employmentSetting",
                                                                    "plural": false,
                                                                    "selections": (v12 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CompensatoryTimeSetting",
                                                                    "kind": "LinkedField",
                                                                    "name": "timeStore",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v5 /*: any*/),
                                                                        (v7 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "timeStoreEvent",
                                                                            "plural": false,
                                                                            "selections": (v13 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "CompensatoryTime",
                                                                    "kind": "LinkedField",
                                                                    "name": "times",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "description",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": (v8 /*: any*/),
                                                                            "concreteType": "TimeSpanUnitValue",
                                                                            "kind": "LinkedField",
                                                                            "name": "time",
                                                                            "plural": false,
                                                                            "selections": (v11 /*: any*/),
                                                                            "storageKey": "time(unit:\"HOUR\")"
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "TimeSpanUnitValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "totalTime",
                                                                    "plural": false,
                                                                    "selections": (v11 /*: any*/),
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "ISchedulableEntity",
                                            "abstractKey": "__isISchedulableEntity"
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v4 /*: any*/),
                    "filters": [
                        "model"
                    ],
                    "handle": "connection",
                    "key": "RunningSchedulesInformationByMonthQuery_schedulableEntities",
                    "kind": "LinkedHandle",
                    "name": "schedulableEntities"
                }
            ]
        },
        "params": {
            "cacheID": "413a68fd438cc820fea9704e4d23126d",
            "id": null,
            "metadata": {},
            "name": "RunningSchedulesInformationByMonthQuery",
            "operationKind": "query",
            "text": "query RunningSchedulesInformationByMonthQuery(\n  $month: DateTime!\n  $model: SchedulableEntitiesQueryRequestInput\n) {\n  ...RunningSchedulesInformationByMonth_fragment_1Suk8x\n}\n\nfragment RunningSchedulesInformationByMonthRow_fragment_3vjFD7 on ISchedulableEntity {\n  __isISchedulableEntity: __typename\n  id\n  name\n  color\n  scheduleTimesByMonth(month: $month) {\n    timeReport {\n      id\n    }\n    summary {\n      totalTime(unit: HOUR) {\n        value\n        unit\n      }\n      workedTime(unit: HOUR) {\n        value\n        unit\n      }\n      absenceTime(unit: HOUR) {\n        value\n        unit\n      }\n    }\n    employmentSummaries {\n      employment {\n        id\n        title\n      }\n      timeReportSummary {\n        expectedWorkTime(unit: HOUR) {\n          value\n          unit\n        }\n        eventSummaries {\n          event {\n            id\n            name\n          }\n          isWork\n          nonRegularPartsSummary {\n            event {\n              id\n              name\n            }\n            duration(unit: SECOND) {\n              value\n              unit\n            }\n          }\n          unit\n          value\n        }\n      }\n    }\n    compensatoryTimes {\n      employmentSetting {\n        id\n        title\n      }\n      timeStore {\n        id\n        name\n        timeStoreEvent {\n          id\n          name\n        }\n      }\n      times {\n        description\n        time(unit: HOUR) {\n          value\n          unit\n        }\n      }\n      totalTime {\n        value\n        unit\n      }\n    }\n  }\n}\n\nfragment RunningSchedulesInformationByMonth_fragment_1Suk8x on Query {\n  schedulableEntities(first: 10, model: $model) {\n    edges {\n      node {\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on ISchedulableEntity {\n          __isISchedulableEntity: __typename\n          ...RunningSchedulesInformationByMonthRow_fragment_3vjFD7\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "494e468e9892853299cfe8e75e34f5bc";
export default node;
